import * as React from 'react';
import clsx from 'clsx';
import { Inline, Text, Radio } from '@treatwell/ui';
import { AllBrandsId } from './BrandFilter';
import * as styles from './BrandFilterItem.module.css';

interface Props {
  value: number | AllBrandsId;
  label: string;
  isSelected?: boolean;
  onClick: () => void;
}

export function BrandFilterItem(props: Props): React.ReactElement {
  const { label, onClick, isSelected, value } = props;
  return (
    <Inline justify="between" className={styles.filter}>
      <Text
        type="caption"
        as="label"
        htmlFor={label}
        className={clsx(styles.label, styles.overflowEllipsis)}
      >
        {label}
      </Text>
      <Radio
        id={label}
        name={label}
        value={String(value)}
        onChange={onClick}
        checked={isSelected}
      />
    </Inline>
  );
}
